module.exports = __webpack_public_path__ + "static/img/spec1-pc.73ec828.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spec1-pc.jpeg
// module id = xDsm
// module chunks = 1